<mat-form-field appearance="fill">
    <mat-label>Account</mat-label>
    <mat-select [(ngModel)]="accountId">
        <mat-option *ngFor="let a of accounts" [value]="a.id">
            <span class="account-info mat-caption">{{a.id}}</span>
            <span class="transparent">/</span>
            {{a.name}}
        </mat-option>
    </mat-select>
</mat-form-field>
<mat-form-field appearance="fill">
<mat-label>Fahrzeug</mat-label>
    <mat-select [disabled]="!vehicles" [(ngModel)]="connection.troId">
        <ng-container *ngIf="vehicles">
            <ng-container *ngFor="let v of vehicles.list">
                <mat-optgroup label="Nicht Verwendet">
                    <mat-option *ngIf="!v.used" [value]="v.troId">
                        <span class="vehicle-info mat-caption">{{v.troId}}</span>
                        <span class="transparent">/</span>
                        {{v.licensePlate || ''}}
                        <span class="transparent">/</span>
                        <span class="mat-caption">IMEI: {{v.imei}}</span>
                    </mat-option>
                </mat-optgroup>
                <mat-optgroup label="Bereits verwendet">
                    <mat-option *ngIf="v.used" [value]="v.troId">
                        <span class="vehicle-info mat-caption">{{v.troId}}</span>
                        <span class="transparent">/</span>
                        {{v.licensePlate || ''}}
                        <span class="transparent">/</span>
                        <span class="mat-caption">IMEI: {{v.imei}}</span>
                    </mat-option>
                </mat-optgroup>
            </ng-container>
        </ng-container>
    </mat-select>
</mat-form-field>
<br>
<mat-checkbox [(ngModel)]="showDetails">Fahrzeugdetails anzeigen</mat-checkbox>
<div class="details" *ngIf="!vehicle && showDetails">
    <h3>Fahrzeug Info</h3>
    <p>Bitte ein Fahrzeug auswählen, um Details anzuzeigen.</p>
</div>
<div class="details" *ngIf="vehicle && showDetails">
    <h3>Fahrzeug Info</h3>
    <table class="table w-auto">
        <thead>
        <tr>
            <th>Feld</th>
            <th>Wert</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let vDat of (vehicle.data | keyvalue)">
            <td>{{vDat.key}}</td>
            <td>{{vDat.value}}</td>
        </tr>
        </tbody>
    </table>
</div>
